import { styled } from '@mui/material'
import { Link } from 'react-router-dom-v5-compat'

export const StyledLink = styled(Link, {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active?: boolean }>(({ active }) => ({
  whiteSpace: 'nowrap !important' as const,
  textDecoration: 'none',
  color: 'inherit',
  margin: '0 0.25rem',
  ...(active && {
    '& button': {
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
    },
  }),
}))

export const Content = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%',
  maxWidth: '100%',
})

export const Right = styled('div')({
  display: 'flex',
})

export const HelpMenuContainer = styled('div')(({ theme }) => ({
  alignSelf: 'center',
  marginRight: theme.breakpoints.down('md') ? 0 : 15,
  display: 'flex',
  alignItems: 'center',
  gap: 8,
}))
